module.exports = __webpack_public_path__ + "static/media/ruble-sign.63715ab4.svg";